export const LOG_OUT = "LOG_OUT";
export const LOGIN = "LOGIN";
export const LOGIN_VERIFY = "LOGIN_VERIFY";

export const LOADING = "LOADING";
export const LOADING_ERROR = "LOADING_ERROR";

export const LEDGER = "LEDGER";
